import { render, staticRenderFns } from "./PlaylistPRO.vue?vue&type=template&id=55464ce2&scoped=true&lang=html&"
import script from "./PlaylistPRO.vue?vue&type=script&lang=js&"
export * from "./PlaylistPRO.vue?vue&type=script&lang=js&"
import style0 from "./PlaylistPRO.vue?vue&type=style&index=0&id=55464ce2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55464ce2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VDivider,VLayout,VSelect,VSnackbar,VTextField})
